import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { L10nLocale, L10N_LOCALE } from 'angular-l10n';

export interface ErrorData {
  title: string,
  message?: string,
  error?: string,
  ok?: string,
}

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: false
})
export class ErrorComponent {

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    public dialogRef: MatDialogRef<ErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ErrorData,
  ) { }

}
